import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentAwaitingPickup() {
  return (
    <FulfillmentQueue
      title="Awaiting Pickup"
      statusFilter="awaiting_pickup"
      emptyMessage="No orders awaiting pickup"
    />
  );
}
